// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-mask {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: block;
  overflow-y: auto;
}
.global-id-type-ahead .pui-form-type-ahead-input-async-multi-select {
  max-height: 15vh;
  overflow-y: auto;
}
#inYearBudReqModalCloseBtn span {
  font-size: x-large;
}
#inYearBudgetRequestsModal {
  position: absolute;
  z-index: 100;
}
.pui-o-container,
.pui-grid-container {
  padding-right: 0;
  padding-left: 0;
}
#in-year-bud-req-modal-p xs {
  font-size: small;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.popover-info-list {
  margin-left: 2.24rem;
  margin-top: unset;
}
.popover-info-list-item {
  list-style-type: unset;
}
.popover-info-request-type {
  font-size: small;
  font-weight: bold;
  margin-bottom: unset;
}
.popover-info-request-info {
  font-size: small;
  margin-bottom: unset;
}
.pui-form .use-existing-global-id-checkbox-container {
  margin-top: 1.6rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
